import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Listing/campaign images are served from this origin; preconnecting lets the browser finish
// DNS/TLS setup before the first image request instead of during it. Done here rather than as
// a static <link> in index.html because the origin differs per environment (environment.ts is
// swapped at build time via fileReplacements, but index.html is not).
if (environment.mediaOrigin) {
  const preconnectLink = document.createElement('link');
  preconnectLink.rel = 'preconnect';
  preconnectLink.href = environment.mediaOrigin;
  preconnectLink.crossOrigin = 'anonymous';
  document.head.appendChild(preconnectLink);
}

bootstrapApplication(AppComponent, appConfig).catch(error => {
  if (!environment.production) {
    console.info('Bootstrap error:', error);
  }
});
